import { combineReducers } from "redux";
import createNamedWrapperReducer from "@frameworks/web/redux/feature/Markets/Common/Reducers/wrapperReducer";
import DpBillReport from "./DpBillReport";
export default combineReducers({
    dpBillReport: createNamedWrapperReducer(DpBillReport, "DpBillsDetailsReport"),
});
